import { render, staticRenderFns } from "./EditMechanism.vue?vue&type=template&id=afc704a0&scoped=true"
import script from "./EditMechanism.vue?vue&type=script&lang=js"
export * from "./EditMechanism.vue?vue&type=script&lang=js"
import style0 from "./EditMechanism.vue?vue&type=style&index=0&id=afc704a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc704a0",
  null
  
)

export default component.exports